<template>
  <div class="layout">
    <PlatFormPage :menu-list="menuList" :title="getPageTitle" @onSideMenuClick="onsidemenuclick"></PlatFormPage>
  </div>
</template>

<script>
import PlatFormPage from '../../../components/common/PlatFormPage'
import {mapActions} from 'vuex'

export default {
  name: 'productplatform',
  components: {
    PlatFormPage
  },
  data () {
    return {
      menuList: [
        {
          id: 1,
          title: '首页',
          icon: 'icon-home',
          url: '/bootpage',
          child: []
        },
        {
          id: 4,
          title: '线索',
          icon: 'icon-user',
          path: '',
          child: [{
          //   id: 41,
          //   title: '访客列表',
          //   url: '/visitor',
          // }, {
            id: 42,
            title: '咨询列表',
            url: '/consult_list',
          }]
        },
        {
          id: 2,
          title: '商品',
          icon: 'icon-products',
          url: '',
          child: [{
            id: 21,
            title: '商品列表',
            url: '/productlist',
          // },{
          //   id: 22,
          //   title: '商品菜单',
          //   url: '/productpagelist',
          },
          ]
        },
        {
          id: 10,
          title: '素材',
          icon: 'icon-material',
          url: '',
          child: [
          //   {
          //   id: 101,
          //   title: '落地页',
          //   url: '/materialbasepage',
          //   // },
            {
            id: 102,
            title: '引导页',
            url: '/guidepage',
          }, {
            id: 103,
            title: '视频库',
            url: '/videorepository',
          }, {
            id: 104,
            title: '图片库',
            url: '/picturerepository',
            // }, {
            //     id: 105,
            //     title: '图标库',
            //     url: '/iconrepository',
          }, {
            id: 106,
            title: '案例库',
            url: '/examplerepository',
          }]
        },
        {
          id: 6,
          title: '基础',
          icon: 'icon-set',
          url: '/basesettings',
        }
      ]
    }
  },
  computed: {
    getPageTitle () {
      let title = this.$store.state.company.entName || '老刀号  超级产品说明书'
      return title
    }
  },
  mounted () {
    this.getCurrentEntInfo()
  },
  methods: {
    onsidemenuclick (item) {
    },
    ...mapActions([
      'changeProductClassList',
      'getEnterproseClassList',
      'getCurrentEntInfo'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
